import { createAction } from "redux-actions";

// TODO: UPDATE PLACE HOLDER
export const setChapiProp = createAction(
  "chapi/SET_CHAPI_PROP",
  payload => payload
);
